import { get, put, deleteRequest } from 'utils/api';

export const getWalletTopUpOffers = (data) => {
  return get(`/wallets/top_up_offers`, data);
};

export const getWalletTopUpOfferHistory = () => {
  return get(`/wallets/top_up_offers/history`);
};

export const saveWalletTopUpOffers = (data) => {
  return put(`/wallets/top_up_offers`, data);
};

export const deleteWalletTopUpOffer = (data) => {
  return deleteRequest(`/wallets/top_up_offers?${new URLSearchParams(data)}`);
};

export const walletTopUpOffer = {
  getWalletTopUpOffers,
  saveWalletTopUpOffers,
  getWalletTopUpOfferHistory,
  deleteWalletTopUpOffer,
};
